<template>

  <v-responsive
    aspect-ratio=".611"
    style="width: 100%; margin: auto; max-width: calc(100vw - 12px)"
  >

        <!-- مودال کیوآر -->
        <universal-qr-modal
          v-model="showQrDialog"
          :title="value?.visitName || 'کارت ویزیت'"
          :subtitle="'برای دریافت اطلاعات، کیوآر زیر را اسکن کنید.'"
          :identifier="value?.identifier || ''"
          :profile-avatar="value?.photo?.profile || ''"
          :primary-color="primaryActionColor"
          :svg-data="qrSvgDataUrl"
        />
        <!-- دکمه شناور اسکن QR -->
        <v-btn
          fab
          x-small
          elevation="4"
          class="qr-floating-btn"
          title="مشاهده و اسکن کیوآر کد"
          @click="showQrDialog = true"
        >
          <v-icon size="18">mdi-qrcode-scan</v-icon>
        </v-btn>

  <component
    :is="components[value.photo.transition || 'scale']"
    mode="out-in"
    origin="center"
  >
    <div
      v-if="showWelcome && value.photo.hasWelcome"
      key="loading"
      class="col-md-11 mx-auto elevation-3 d-flex"
      style="min-height: 80vh"
    >
      <div v-if="value.photo.welcome === ''" class="col m-auto">
        <atom-spinner
          :animation-duration="1000"
          :size="80"
          class="mx-auto justify-content-center"
          color="#ff1d5e"
        />
      </div>
      <div v-if="value.photo.welcome !== ''" class="m-auto">
        <img
          :src="value.photo.welcome"
          alt=""
          class="bg-white rounded-circle mx-auto my-auto"
          width="100"
        />
      </div>
    </div>

    <div
      v-else-if="locationPage && value.coordinates"
      key="location"
      class="col-md-12 elevation-3"
    >
      <v-card-title class="px-0 pt-0 justify-end">
        <v-btn
          class="mx-2 mr-auto text-left"
          color="white"
          @click="locationPage = false"
        >
          بازگشت
          <v-icon class="ms-2" color="black">mdi-keyboard-backspace</v-icon>
        </v-btn>
      </v-card-title>

      <div>
        <p>
          <span class="fa fa-car ml-1 text-danger"></span>
          پس از کلیک بر روی لوکیشن مسیریاب خودرا انتخاب کنید.
        </p>

        <v-card
          v-if="locLoading"
          class="d-flex align-center justify-center"
          flat
          height="400"
          width="100%"
        >
          <atom-spinner
            :animation-duration="1000"
            :size="120"
            class="mx-auto justify-content-center"
            color="#ff1d5e"
          />
        </v-card>

        <mapir
          :apiKey="value.apiKey"
          :center="value.coordinates"
          :zoom="17"
          class="col-md-12"
          style="width: 100%; height: 400px"
          @click.self="openMap"
        >
          <mapNavigationControl position="top-right" />
          <mapMarker
            :coordinates.sync="value.coordinates"
            color="red"
            kind="marker"
            readonly
          >
            <template v-slot:marker>
              <v-icon>mdi-map-marker</v-icon>
            </template>
          </mapMarker>
        </mapir>
      </div>

      <div class="col-md-12 flex py-2 my-3">
        <p>
          <span><v-icon color="red">mdi-map-marker</v-icon></span
          >{{ value.address }}
        </p>
      </div>
    </div>

    <div
      v-else
      key="theme"
      v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
      :class="{ flipped: flipped }"
      class="flip-card rounded-lg"
    >
      <div class="flip-card-inner rounded-lg">
        <v-card
          :style="{ background: value.pallete.headColor }"
          class="flip-card-front rounded-lg overflow-hidden"
          flat
        >
          <v-responsive
            :aspect-ratio="16 / 9"
            :style="{
              background: value?.photo?.headBackground
                ? `url('${value?.photo?.headBackground}')`
                : value?.pallete?.bodyColor,
            }"
            class="overflow-visible rounded-t-lg front-responsive"
          >
            <div
              v-if="value.photo.profile"
              :class="{ 'active-float': activeFloating }"
              class="white rounded-circle front-avatar"
            >
              <div
                :style="{ backgroundImage: `url(${value.photo.profile})` }"
                class="bg-filter"
              />
              <img :src="value.photo.profile" alt="" />
            </div>
          </v-responsive>

          <div
            v-if="
              value.socialMedia && Object.keys(value.socialMedia).length > 0
            "
            :class="{ active: activeFloating }"
            :style="{ background: value.pallete.bodyColor }"
            class="floating-social social-front"
          >
            <v-btn
              :color="value.pallete.textColor"
              icon
              @click="activeFloating = !activeFloating"
            >
              <v-scale-transition mode="out-in" origin="middle">
                <v-icon v-if="!activeFloating" key="share-variant"
                  >mdi-share-variant</v-icon
                >
                <v-icon v-else key="close">mdi-close</v-icon>
              </v-scale-transition>
            </v-btn>

            <div class="floating-content">
              <v-btn
                v-for="(item, i) in computeFields"
                :key="i"
                :style="{ background: value.pallete.headColor }"
                class="ma-2"
                fab
                @click="goToUrl(item.url, item.pattern)"
              >
                <img
                  :src="item.img"
                  alt=""
                  class="img-fluid"
                  style="max-width: calc(100% - 22px)"
                />
              </v-btn>
            </div>
          </div>

          <div
            :style="{ color: value.pallete.textColor }"
            class="card-front-name"
          >
            <v-spacer />
            <v-card-title
              class="font-size-h3 font-weight-bold text-center justify-center text-break"
              v-text="value.organizationName"
            />
            <v-card-subtitle
              class="mt-n1 font-size-h6 text-break"
              v-text="value.subOrgan"
            />

            <div class="px-5" style="max-height: 200px; overflow-y: scroll">
              <drag-list v-model="draggingKeys">
                <template v-slot:default="{ item }">
                  <template v-if="item === 'userName' && value.userName">
                    <p v-if="value.userName" class="text-right my-2">
                      <v-icon>mdi-account-outline</v-icon>
                      : {{ value.userName }}
                    </p>
                  </template>
                  <!-- photo -->
                  <template v-if="item === 'photo'">
                    <div style="max-width: calc(100% - 24px)">
                      <image-slider v-model="value.photo.gallery" />
                    </div>
                  </template>

                  <template v-if="item === 'workField' && value.workField">
                    <p v-if="value.workField" class="text-right my-2">
                      <v-icon>mdi-briefcase-account</v-icon>
                      : {{ value.workField }}
                    </p>
                  </template>

                  <template v-if="item === 'aboutUs' && value.aboutUs">
                    <div v-if="value.aboutUs" class="my-2">
                      <span><v-icon>mdi-comment-account-outline</v-icon></span>
                      :
                      <span class="font-weight-bolder">درباره ما</span>
                      <div class="col-md-12 mb-2">
                        <pre
                          class="text-justify my-0"
                          style="white-space: pre-line"
                          v-html="trancateTxts"
                        />
                        <v-btn
                          v-if="
                            value.aboutUs.length > 200 ||
                            value.aboutUs.split('<div>').length > 3
                          "
                          class="ms-n4"
                          color="primary"
                          text
                          @click="isTruncate = !isTruncate"
                        >
                          {{ isTruncate ? "مشاهده بیشتر" : "مشاهده کمتر" }}
                        </v-btn>
                      </div>
                    </div>
                  </template>

                  <template v-if="item === 'extraFields' && value.extraFields">
                    <extra-shown v-model="value.extraFields" />
                  </template>

                  <template v-if="item === 'phoneNumber' && value.phoneNumber">
                    <div>
                      <p
                        v-for="(p, i) in value.phoneNumber"
                        :key="i"
                        class="text-right clickable link-tag"
                        @click="rangMe(p.number)"
                      >
                        <v-icon color="red">mdi-phone-outline</v-icon>
                        :
                        <a
                          :href="`tel:${p.number.replace(/[^\d]/g, '')}`"
                          class="link-tag text-left clickable mx-1"
                          target="_blank"
                          dir="ltr"
                        >
                          {{ p.number.replace(/[^\d\+]/g, "") }}
                        </a>
                        {{ p.text }} {{ p.number.replace(/[\d\^+]/g, "") }}
                      </p>
                    </div>
                  </template>

                  <template v-if="value.fax && item === 'fax'">
                    <p v-if="value.fax" class="text-right my-2">
                      <v-icon>mdi-fax</v-icon>
                      : {{ value.fax }}
                    </p>
                  </template>

                  <template v-if="value.location && item === 'location'">
                    <div class="text-right">
                      <pre
                        v-if="value.location"
                        class="d-flex justify-start align-start my-2"
                      >
                      <v-icon>mdi-map-marker</v-icon>: {{ value.location }}
                    </pre
                      >
                    </div>
                  </template>

                  <template v-if="value.codePostal && item === 'codePostal'">
                    <p v-if="value.codePostal" class="text-right my-2">
                      <v-icon>mdi-post</v-icon>
                      : {{ value.codePostal }}
                    </p>
                  </template>

                  <template v-if="value.email && item === 'email'">
                    <a :href="`mailto:${value.email}`" target="_blank">
                      <p
                        v-if="value.email"
                        class="text-right my-2 clickable link-tag"
                      >
                        <span
                          ><v-icon color="red">mdi-email-outline</v-icon></span
                        >
                        : {{ value.email }}
                      </p>
                    </a>
                  </template>

                  <template v-if="value.website && item === 'website'">
                    <p
                      v-if="value.website"
                      class="text-right my-3 clickable link-tag"
                      @click="goToUrl(value.website)"
                    >
                      <span><v-icon color="blue">mdi-earth</v-icon></span> :
                      {{ value.website }}
                    </p>
                  </template>
                </template>
              </drag-list>
            </div>

            <v-spacer />

            <v-card-actions class="card-front-action">
              <v-btn
                :color="value.pallete.textColor"
                class="mx-2 btn-action"
                icon
                @click="flipped = !flipped"
              >
                <v-icon size="29">mdi-account</v-icon>
              </v-btn>

              <v-btn
                v-if="value.companyNumber"
                :color="value.pallete.textColor"
                :href="`tel:${value.companyNumber}`"
                class="mx-2"
                icon
              >
                <v-icon size="29">mdi-phone</v-icon>
              </v-btn>

              <v-btn
                v-if="value.coordinates"
                :color="value.pallete.textColor"
                class="mx-2"
                icon
                @click="locationPage = true"
              >
                <v-icon size="29">mdi-map-marker</v-icon>
              </v-btn>

              <v-btn
                v-if="
                  (value.phoneNumber &&
                    value.phoneNumber.length > 0 &&
                    value.phoneNumber[0].number) ||
                  value.companyNumber
                "
                :color="value.pallete.textColor"
                :loading="vcfLoading"
                class="mx-2"
                icon
                @click="getVcf"
              >
                <v-icon size="29">mdi-plus</v-icon>
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>

        <v-card
          :dark="getDarkTheme"
          :style="{ background: value.pallete.bodyColor }"
          class="flip-card-back rounded-lg overflow-hidden"
          flat
        >
          <div
            v-if="
              value.socialMedia && Object.keys(value.socialMedia).length > 0
            "
            :class="{ active: activeFloating }"
            class="floating-social social-back"
          >
            <v-btn
              :color="value.pallete.textColor"
              icon
              @click="activeFloating = !activeFloating"
            >
              <v-scale-transition mode="out-in" origin="middle">
                <v-icon v-if="!activeFloating" key="share-variant"
                  >mdi-share-variant</v-icon
                >
                <v-icon v-else key="close">mdi-close</v-icon>
              </v-scale-transition>
            </v-btn>

            <div class="floating-content">
              <v-btn
                v-for="(item, index) in computeFields"
                :key="index"
                :style="{ background: value.pallete.headColor }"
                class="ma-2"
                fab
                @click="goToUrl(item.url, item.pattern)"
              >
                <img
                  :src="item.img"
                  alt=""
                  class="img-fluid"
                  style="max-width: calc(100% - 12px)"
                />
              </v-btn>
            </div>
          </div>

          <v-card-text class="card-back-content custom-scrollbar">
            <div class="pt-4 text-right">
              <div>
                <turn-viewer
                  :title="value.PicSelector.title"
                  :description="value.PicSelector.description"
                  v-if="theme === 'turning'"
                  v-model="value.gallery[0].images"
                />

                <catalog-swiper
                  v-else-if="theme === 'slide'"
                  v-model="value.gallery[0].images"
                  :title="value.PicSelector.title"
                  :description="value.PicSelector.description"
                  :style="{
                    background: value.PicSelector.sectionColor.backGround,
                    color: value.PicSelector.sectionColor.text,
                  }"
                />

                <vertical-catalog
                  v-else
                  :title="value.PicSelector.title"
                  :description="value.PicSelector.description"
                  v-model="value.gallery[0].images"
                  :style="{
                    background: value.PicSelector.sectionColor.backGround,
                    color: value.PicSelector.sectionColor.text,
                  }"
                />
                <show-more-catalog
                  :value="value"
                  class="pt-2"
                  :style="{
                    background: value.PicSelector.sectionColor.backGround,
                    color: value.PicSelector.sectionColor.text,
                  }"
                />
              </div>
            </div>
          </v-card-text>

          <v-card-actions class="card-back-action">
            <v-btn
              :color="value.pallete.textColor"
              class="mx-2 btn-action"
              icon
              @click="flipped = !flipped"
            >
              <v-icon size="29">mdi-backup-restore</v-icon>
            </v-btn>

            <v-btn
              v-if="value.companyNumber"
              :color="value.pallete.textColor"
              :href="`tel:${value.companyNumber}`"
              class="mx-2"
              icon
            >
              <v-icon size="29">mdi-phone</v-icon>
            </v-btn>

            <v-btn
              v-if="value.coordinates"
              :color="value.pallete.textColor"
              class="mx-2"
              icon
              @click="locationPage = true"
            >
              <v-icon size="29">mdi-map-marker</v-icon>
            </v-btn>

            <v-btn
              v-if="
                (value.phoneNumber &&
                  value.phoneNumber.length > 0 &&
                  value.phoneNumber[0].number) ||
                value.companyNumber
              "
              :color="value.pallete.textColor"
              :loading="vcfLoading"
              class="mx-2"
              icon
              @click="getVcf"
            >
              <v-icon size="29">mdi-plus</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </component>
  </v-responsive>
</template>

<script>
import axios from "axios";
import {
  textDirectionMixin,
  detectLanguage,
  getTextAlign,
} from "@/utilities/textDirection";
import { Bus, debounce } from "@/main";
import {
  mapGeolocateControl,
  mapir,
  mapMarker,
  mapNavigationControl,
} from "mapir-vue";
import { AtomSpinner } from "epic-spinners";
import {
  VFadeTransition,
  VScaleTransition,
  VSlideXTransition,
  VSlideYTransition,
} from "vuetify/lib";
import FloatingBtn from "../../../otherQrTypes/photoGallery/components/floatingBtn";
import GallerySlider from "../../../businessPage/components/view/gallerySlider";
import ImageSlider from "../../../../components/Gallery/imageSlider";
import DragList from "@/view/pages/qrland/dragList";
import ExtraShown from "../../../../components/Product/extraShown";
import TurnViewer from "@/view/pages/otherQrTypes/leafletCatalog/components/turnViewer";
import CatalogSwiper from "@/view/pages/otherQrTypes/leafletCatalog/catalogSwiper";
import VerticalCatalog from "@/view/pages/otherQrTypes/leafletCatalog/components/verticalCatalog";
import { mapGetters, mapActions } from "vuex";
import ShowMoreCatalog from "@/view/pages/otherQrTypes/leafletCatalog/showMoreCatalog";
import UniversalQrModal from "../../../../components/UniversalQrModal.vue";

export default {
  name: "catalogShow",

  components: {
    VerticalCatalog,
    CatalogSwiper,
    TurnViewer,
    ExtraShown,
    DragList,
    ImageSlider,
    GallerySlider,
    FloatingBtn,
    mapGeolocateControl,
    mapir,
    mapMarker,
    mapNavigationControl,
    AtomSpinner,
    ShowMoreCatalog,
    UniversalQrModal
  },
  mixins: [textDirectionMixin],

  props: {
    value: Object,
    theme: String,
    orders: {
      type: Array,
      default: () => [],
    },
    qrSvgDataUrl: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    showQrDialog: false,
    activeFloating: false,
    flipped: false,
    isTruncate: true,
    vcfLoading: false,
    showWelcome: false,
    locationPage: false,
    locLoading: false,
    components: {
      scale: VScaleTransition,
      slideX: VSlideXTransition,
      slideY: VSlideYTransition,
      fade: VFadeTransition,
    },
  }),

  mounted() {
    Bus.$on("showMe", (value) => {
      if (this.value?.photo.hasWelcome) {
        this.showWelcome = true;
        this.locationPage = false;
        setTimeout(() => {
          this.locationPage = false;
          this.showWelcome = false;
        }, 3000);
      }
    });

    if (
      !this.value ||
      !this.value.pallete ||
      Object.keys(this.value.pallete).length <= 0 ||
      ["qr.name.editCatalog", "qr.name.id.editCatalog", "qr.catalog"].includes(
        this.$route.name,
      )
    ) {
      this.valueComputed.pallete = {
        headColor: "linear-gradient(to bottom, #FF00F6FF, #11001AFF)",
        bodyColor: "linear-gradient(to top left, #A238C1FF, #F2D2FFFF)",
        textColor: "#ffffff",
        borderColor: "#393939",
      };
    }

    if (
      !this.value?.photo ||
      !this.value?.photo?.headBackground ||
      ["qr.name.editCatalog", "qr.name.id.editCatalog", "qr.catalog"].includes(
        this.$route.name,
      )
    )
      this.value.photo.headBackground =
        "/media/defaults/visitFlippedDefault.webp";

    setTimeout(() => this.setKeys(this.data), 200);
    this.$forceUpdate();
  },
  beforeDestory() {
    this.$root.$off("fetchDragList");
    this.$root.$off("showMe");
  },
  computed: {
    primaryActionColor() {
      return this.value?.pallete?.bodyColor || "#1976D2";
    },

    ...mapGetters("localstorage", [
      "createQrID",
      "alllangs",
      "defaultLang",
      "mainDatalang",
      "currentlanguage",
    ]),

    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    trancateTxts() {
      this.value?.photo?.transition;
      this.value?.socialMedia;
      let about = this.value.aboutUs || "";

      const more = about.split("<div>").length > 3;

      const text = () => {
        let variable = about.split("<div>");
        let generatedText = "";
        for (let a = 0; a <= 3; a++) {
          generatedText += "<div>" + variable[a];
        }
        return generatedText;
      };

      about =
        (about.length > 200 || more) && this.isTruncate
          ? (more ? text() : about.slice(0, 100)) + "&hellip;"
          : about;

      return about
        .replace(
          /style="width:604px;height:270px" /gms,
          'style="width:100%;height:auto"',
        )
        .replace(/style="display: block;padding-top: 57%"/gms, "");
      // return about.replace(/<div class="h_iframe-.*<iframe/gms, '<iframe ').replace(/ style="width:604px;height:270px" /gms, '');
    },
    thirdOne() {
      let top = {};

      Object.entries(this.value.socialMedia)
        .slice(0, 3)
        .forEach(([x, y]) => {
          top[x] = y[0];
        });

      return top;
    },
    computeFields() {
      let extra = [];

      Object.entries(this.value.socialMedia).forEach(([x, y]) => {
        extra.push(...y);
      });

      return extra;
    },
    getHeaderImg() {
      if (!this.expand) {
        return (
          this.value?.photo?.profile ??
          this.value?.photo?.headBackground ??
          false
        );
      }

      return this.value?.photo?.headBackground ?? false;
    },
    hasExtra() {
      let arr = this.value.extraFields.filter(
        (item) => !!item.name || !!item.icon || !!item.value,
      );
      return arr && arr.length > 0;
    },
    getDarkTheme() {
      let rgx = new RegExp(/#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})/, "gm");
      if (this.value?.pallete?.bodyColor) {
        let hex = this.value.pallete.bodyColor.match(rgx);
        let count = 0;
        for (let i = 0; i < hex.length; i++) {
          count += this.brightness(hex[i]);
        }
        count = count / hex.length;
        this.value.pallete.isDarkBody = count <= 160;
        return count <= 160;
      }
      return false;
    },
    draggingKeys: {
      get() {
        return this.orders;
      },
      set(val) {
        this.$emit("update:orders", val);
      },
    },
  },

  watch: {
    locationPage(val) {
      if (val) {
        this.locLoading = true;
        this.getlatLng();
      }
    },
    value: {
      deep: true,
      immediate: true,

      handler(val) {
        this.setKeys(val);
      },
    },
  },
  created() {
    this.$root.$on("fetchDragList", this.setKeys);
  },
  methods: {
    ...mapActions("localstorage", ["setDraggingKeysOrder"]),

    openMap() {
      let agent = window.navigator.userAgent;
      let type = "https://www.google.com/maps/@";

      if (agent.toLowerCase().search("android") > 0) {
        type = "geo:";
      } else if (
        agent.search("iPad") > 0 ||
        agent.search("iPhone") > 0 ||
        agent.search("iPod") > 0
      ) {
        type = "maps:";
      }

      window.open(
        `${type}${this.value.coordinates[1]},${this.value.coordinates[0]}?q=${this.value.coordinates[1]},${this.value.coordinates[0]}`,
        "_blank",
      );
    },
    goToUrl(url, pattern = null) {
      let setUrl = "";
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith("http")) {
        if (emailRegex.test(url)) setUrl = "mailto:";
        else if (pattern)
          setUrl = pattern.startsWith("http") ? pattern : "https://" + pattern;
        else setUrl = "https://";
      }

      let a = document.createElement("a");
      a.setAttribute("href", setUrl + url);
      a.setAttribute("target", "_blank");
      a.click();
    },
    rangMe(url) {
      let a = document.createElement("a");
      a.setAttribute("href", `tel:${url}`);
      a.click();
    },
    getlatLng() {
      axios({
        method: "GET",
        baseURL: "https://map.ir/reverse",
        params: {
          lat: this.value.coordinates[1],
          lon: this.value.coordinates[0],
        },
        timeout: 15000,
        headers: {
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
          Accept: "application/json",
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          this.value.address = response.data.address;
        })
        .finally(() => (this.locLoading = false));
    },
    getVcf() {
      this.vcfLoading = true;

      const info = {
        fax: undefined,
        email: undefined,
        visitName: undefined,
        organizationName: undefined,
        subOrgan: undefined,
        userName: undefined,
        workField: undefined,
        phoneNumber: undefined,
        companyNumber: undefined,
        location: undefined,
        city: undefined,
        photo: undefined,
        codePostal: undefined,
        province: undefined,
        country: undefined,
        website: undefined,
        socialMedia: undefined,
        aboutUs: undefined,
        address: undefined,
      };

      Object.keys(info).forEach((x) => {
        info[x] = this.value[x];
      });
      axios
        .post(process.env.VUE_APP_VCF, info)
        .then((x) => {
          var a = document.createElement("a"); //Create <a>
          a.href = "data:text/vcard;charset=utf-8;base64," + x.data; //Image Base64 Goes here
          a.download = `${info.userName}.vcf`; //File name Here
          a.click(); //Downloaded file
        })
        .finally(() => (this.vcfLoading = false));
    },
    extraIsLink(item) {
      return !!item.link && !!item.link.length;
    },
    fixLink(link) {
      return !!link?.startsWith("http") ? link : "https://" + link;
    },
    swipe(dir) {
      if (dir === "Right" && !this.flipped) {
        this.flipped = true;
      } else if (dir === "Left" && this.flipped) {
        this.flipped = false;
      }
    },
    brightness(input) {
      const color = "" + input,
        isHEX = color.indexOf("#") == 0;
      if (isHEX) {
        const m = color
          .substr(1)
          .match(color.length == 7 ? /(\S{2})/g : /(\S{1})/g);
        if (m)
          var r = parseInt(m[0], 16),
            g = parseInt(m[1], 16),
            b = parseInt(m[2], 16);
      }
      if (typeof r != "undefined") return (r * 299 + g * 587 + b * 114) / 1000;
    },
    setKeys(val) {
      if (!val) return;

      let excludes = [
        "pallete",
        "isGradient",
        "city",
        "province",
        "country",
        "socialMedia",
        "center",
        "coordinates",
        "apiKey",
        "PicSelector",
        "textCards",
        "tab_design",
        "video_gallery",
        "gallery",
      ];

      if (this.orders && this.orders.length > 0) {
        let filteredOrders = this.orders.filter((item) => {
          let keyName =
            typeof item === "object" && item !== null ? item.name : item;
          return !excludes.includes(keyName);
        });

        if (filteredOrders.length !== this.orders.length) {
          this.draggingKeys = filteredOrders;
        }
        return;
      }

      let keys = Object.keys(val).filter(
        (k) => !excludes.includes(k) && val[k],
      );

      this.draggingKeys = keys;
    },
  },
};
</script>

<style lang="scss" scoped>
.flip-card {
  background-color: transparent;
  width: 100%;
  max-width: 100%;
  height: 80vh;
  max-height: 630px;
  perspective: 1000px;

  &.flipped {
    .card-front-action {
      visibility: hidden;
    }

    .flip-card-inner {
      transform: rotateY(
        -180deg
      ); /* برای رفع مشکل راست چین به منفی تغییر کرد */
    }

    .flip-card-front > * {
      visibility: hidden;
    }
  }

  .flip-card-inner {
    position: relative;
    width: 100%;
    height: 100%;
    max-width: 100%;
    text-align: center;
    -webkit-transition: transform 0.6s;
    transition: transform 0.6s;
    -webkit-transform-style: preserve-3d !important;
    transform-style: preserve-3d !important;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  }

  .flip-card-front,
  .flip-card-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden !important;
    backface-visibility: hidden !important;
    top: 0;
    left: 0;

    .floating-social {
      margin: 8px 8px 0;
      background: rgba(0, 0, 0, 0);
      text-align: right;
      padding: 4px;
      border-radius: 50% !important;
      height: 44px;
      width: 44px;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
      z-index: 10;
      position: relative;

      .floating-content {
        display: none;
        width: 100%;
        margin-top: 16px;
        justify-content: space-evenly;
        flex-wrap: wrap;
        transform: translateY(-50%);
      }

      &.active {
        margin: 0;
        border-radius: 0 !important;
        position: relative;
        height: 100%;
        width: 100%;

        .floating-content {
          position: absolute;
          top: 20%;
          left: 0;
          display: flex;
          animation: floating-content-anm 0.3s both;
          animation-delay: 0.5s;
        }
      }
    }
  }

  .flip-card-front {
    transform: rotateY(0deg); /* اضافه شده */
    z-index: 2; /* اضافه شده */

    .front-responsive {
      box-sizing: border-box;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      background-position: top !important;
    }

    .front-avatar {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 50%);
      transition: transform 0.3s;
      width: 110px;
      height: 110px;
      border: 3px solid white;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;

      &.active-float {
        transform: translate(-50%, -10px);
      }

      .bg-filter {
        position: absolute;
        inset: -4px;
        background-size: cover;
        filter: blur(1.8px) brightness(1.3) opacity(0.8);
      }

      img {
        position: relative;
        z-index: 2;
        max-width: 100%;
        max-height: 100%;
      }
    }

    .card-front-name {
      bottom: 0;
      left: 0;
      display: flex;
      padding-top: 66.6667%;
      flex-direction: column;
      position: absolute;
      justify-content: flex-end;
      width: 100%;
      height: 100%;
    }

    .card-front-action {
      justify-content: center;

      .btn-action {
        animation: btn-action-anm 5s;
        animation-delay: 2s;
        animation-iteration-count: infinite;
      }
    }
  }

  .flip-card-back {
    transform: rotateY(-180deg); /* به منفی تغییر کرده */
    z-index: 1; /* اضافه شده */
    height: 100%;

    .floating-social {
      z-index: auto !important;
    }

    .card-back-content {
      margin: 16px;
      padding: 16px;
      max-width: calc(100% - 32px);
      height: calc(100% - 132px);
      max-height: calc(100% - 132px);
      overflow-y: auto;
    }

    .card-back-action {
      justify-content: center;

      .btn-action {
        animation: back-btn-action-anm 5s;
        animation-delay: 2s;
        animation-iteration-count: infinite;
      }
    }
  }
}

@keyframes btn-action-anm {
  0% {
    transform: scale(1) translateY(0) rotate(0);
  }
  5% {
    transform: scale(1.3) translateY(-10px) rotate(15deg);
  }
  10% {
    transform: scale(1.4) translateY(-15px) rotate(-15deg);
  }
  14% {
    transform: scale(0.8) translateY(10px) rotateY(-180deg);
  }
  20% {
    transform: scale(1) translateY(0) rotate(0);
  }
}

@keyframes back-btn-action-anm {
  0% {
    transform: rotate(0);
  }
  5% {
    transform: rotate(15deg);
  }
  10% {
    transform: rotate(-25deg);
  }
  20% {
    transform: rotate(360deg);
  }
  30% {
    transform: rotate(0);
  }
  35% {
    transform: rotate(15deg);
  }
  40% {
    transform: rotate(0);
  }
}

@keyframes floating-content-anm {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

pre {
  font-family: Vazir, serif !important;
  white-space: break-spaces;
  overflow: hidden;
  color: inherit !important;
}

iframe {
  border: none;
  border-radius: 8px;
}

.link-tag,
.link-tag .v-icon {
  color: #0985d2;
  cursor: pointer;
}

.link-tag:hover,
.link-tag:hover .v-icon {
  color: #33a9f1;
}
.qr-floating-btn {
  position: absolute;
  top: 14px;
  left: 14px;
  z-index: 20;
  background-color: rgba(255, 255, 255, 0.9) !important;
}
</style>
